<template>
  <div>
    <i v-show="icon" v-if="isElIcon" :class="icon" class="icon"></i>
    <svg-icon v-show="icon" v-else class="icon" :name="icon"></svg-icon>
    <span>{{title}}</span>
  </div>
</template>
<script>
  export default {
    name: 'MenuTextItem',
    props: {
      isRoot: {
        type: Boolean,
        default: false
      },
      icon: {
        type: String,
        default: ''
      },
      title: {
        type: String,
        default: ''
      }
    },
    computed: {
      isElIcon () {
        return this.icon.indexOf('el-icon') !== -1
      }
    }
  }
</script>

<style scoped>
  .icon {
    margin-right: 0px;
  }
  span {
    margin-left: 5px;
  }
</style>
